import { GlobalDialogFormsParams } from '@components/GlobalDialogForms'
import { Container, Divider } from '@mui/material'
import LogoRectangle from 'images/logo_rectangle_new.svg'
import React from 'react'
import { Link } from 'react-router-dom'
import { useQueryParams } from 'use-query-params'
import { ACCOUNT_LOGIN_URL, getWholesaleBlogUrl, WHOLESALE_ROUTES } from '../../../../urls'
import { makeStyles } from '@mui/styles'
import Hidden from '@mui/material/Hidden'
import useScrollDirection, { ScrollDirection } from '../../../../hooks/useScrollDirection'
import useScrollPosition from '@react-hook/window-scroll'
import MobileMenu from '../MobileMenu'
import { useMeQuery } from '@graphql/queries/__generated__/me.generated'
import { useTranslation } from 'react-i18next'
import { getWholesaleMenuLinks } from '../../../../../constants'
import { useBlogListQuery } from '@graphql/queries/__generated__/blog.generated'

const useStyles = makeStyles(() => ({
  btn: {
    backgroundColor: '#F0AE16',
    borderRadius: '30px',
  },
}))

interface IHeaderProps {}

const Header: React.FC<IHeaderProps> = () => {
  const { t } = useTranslation()
  const scrollY = useScrollPosition(60)
  const scrollDir = useScrollDirection()
  const classes = useStyles()

  const [, setParams] = useQueryParams(GlobalDialogFormsParams)

  const meQuery = useMeQuery({
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
  })
  const blogsQueryResult = useBlogListQuery({
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    variables: { first: 1, isWholesale: true },
  })
  const handleOpenSignInDialog = e => {
    e.preventDefault()
    setParams({ global_dialog_form: 'signIn' }, 'replaceIn')
  }

  const isSticky = scrollY > 0
  const blog = blogsQueryResult.data?.blogList.edges.map(edge => edge.node)[0]
  const wholesaleMenuLinks = [...getWholesaleMenuLinks(t)]
  if (blog) {
    wholesaleMenuLinks.push({ url: getWholesaleBlogUrl(blog.slug), title: blog.name })
  }

  return (
    <>
      <header
        className={`header header--wholesale w-full${isSticky ? ' header--sticky' : ''}${
          scrollDir === ScrollDirection.DOWN && scrollY > 200 ? ' header--hidden' : ''
        }`}
      >
        <div className='relative' style={{ zIndex: 500 }}>
          <div className='z-50'>
            <Container maxWidth='lg' disableGutters>
              <div className='flex items-end md:items-center pb-10 md:pb-0'>
                <Hidden mdUp>
                  <div className='w-50'>
                    <React.Suspense
                      fallback={
                        <div id='nav-icon' style={{ width: 30 }}>
                          <span />
                          <span />
                          <span />
                          <span />
                        </div>
                      }
                    >
                      <MobileMenu links={wholesaleMenuLinks} />
                    </React.Suspense>
                  </div>
                </Hidden>
                <div className='block md:hidden flex-1' style={{ height: '35px' }}>
                  <div className='mt-10 relative text-center md:text-left'>
                    <Link id='logo' to={WHOLESALE_ROUTES.HOME} aria-label='home'>
                      <img alt='Wholesale logo' src={LogoRectangle} className='max-h-full' style={{ height: 30 }} />
                    </Link>
                  </div>
                </div>
                <div className='block md:hidden w-50 mr-20'>
                  {!meQuery?.data?.me && (
                    <Link className='text-lg no-underline' to={ACCOUNT_LOGIN_URL} onClick={handleOpenSignInDialog}>
                      {t('signIn', 'Sign In')}
                    </Link>
                  )}
                </div>
              </div>
              <div className='hidden md:block'>
                <div className='my-12 mx-10 relative text-center md:text-left'>
                  <Link id='logo' to={WHOLESALE_ROUTES.HOME} aria-label='home'>
                    <img alt='Wholesale logo' src={LogoRectangle} className='max-h-full h-30' />
                  </Link>
                </div>
              </div>

              <div className='hidden md:flex justify-between py-10' style={{ lineHeight: '40px' }}>
                <nav>
                  <ul className='m-0 p-0 list-none flex'>
                    {wholesaleMenuLinks.map(link => (
                      <li key={link.url}>
                        <Link className='p-16 text-lg no-underline hover:text-indigo-700' to={link.url}>
                          {link.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </nav>
                <nav>
                  {!meQuery?.data?.me && (
                    <Link
                      className='p-16 text-lg no-underline hover:text-indigo-700'
                      to={ACCOUNT_LOGIN_URL}
                      onClick={handleOpenSignInDialog}
                    >
                      {t('signIn', 'Sign In')}
                    </Link>
                  )}
                  <Link
                    className={`py-10 px-16 text-lg no-underline hover:text-indigo-700 ${classes.btn}`}
                    to={WHOLESALE_ROUTES.REGISTRATION}
                  >
                    {t('button.becomeAPartner', 'Become a partner')}
                  </Link>
                </nav>
              </div>
            </Container>
            <Divider />
          </div>
        </div>
      </header>
      <div className='header--placeholder' />
    </>
  )
}

export default Header
